import { type FC, type ReactElement, useEffect, useRef, useState } from "react";
import { TextButton } from "@root/shared/components/TextButton";
import * as styles from "./styles.css";

type Props = {
  heading: string;
  children: ReactElement[] | ReactElement;
};

export const LabelsCassette: FC<Props> = ({ heading, children }) => {
  // 追加済みの資格ラベルのアコーディオン
  const labelsOuterRef = useRef<HTMLDivElement>(null);
  const [isOverflow, setIsOverflow] = useState(false);
  const labelsOuterMaxHeight = 158;
  useEffect(() => {
    const ref = labelsOuterRef.current;
    if (ref) {
      if (ref.clientHeight > labelsOuterMaxHeight) {
        setIsOverflow(true);
      }
    }
  }, []);
  const handleOnClick = () => {
    setIsOverflow(false);
  };

  return (
    <div ref={labelsOuterRef} className={styles.labelsOuter({ isHide: isOverflow })}>
      <p className={styles.labelsHeading}>{heading}</p>
      {children}
      <TextButton
        className={styles.accordionButton({ isShow: isOverflow })}
        onClick={handleOnClick}
        size="small"
      >
        + 続きを見る
      </TextButton>
    </div>
  );
};
